

import $ from 'jquery';
import Headroom from 'headroom.js';

class Nav {

    constructor() {
        this.activeClass = 'mobile-nav-active';
        this.$toggleOpenEl = $('.js-mobile-nav-open');
        this.$toggleCloseEl = $('.js-mobile-nav-close');
        this.$body = $('body');
        this.$header = $('body:not(.no-headroom) .header');

        this.addEventListeners();
        if (this.$header.length) {
            this.headroom();
        }

        // Subnav
        $('.js-toggle-subnav').on('click', () => {
            $('.subnav__wrapper').slideToggle();
        });
    }

    addEventListeners() {
        this.$toggleOpenEl.on('click', () => this.toggleOpen());
        this.$toggleCloseEl.on('click', () => this.toggleClose());
    }

    toggleOpen() {
        this.$body.addClass(this.activeClass);
    }

    toggleClose() {
        this.$body.removeClass(this.activeClass);
    }

    headroom() {
        const headroom = new Headroom(this.$header[0]);
        headroom.init();
    }
}

module.exports = new Nav();



// WEBPACK FOOTER //
// ./source/scripts/components/nav.js